import { getUniversalHelpers } from "../../helpers";
import { Org, OrgId } from "@ollie-sports/models";

export async function org__client__getOrg(p: { orgId: OrgId }): Promise<Org | null> {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  return await h.Org.getDoc(p.orgId);
}

// i18n certified - complete
